import React from "react";
import styles from "./styles.module.scss";

const Loader: React.FC = () => {
    return <div className={styles.loader}></div>;
};

export default Loader;
